<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <!-- <v-text-field
          v-model="filtroNome"
          label="Buscar por nome"
          prepend-icon="mdi-magnify"
          class="mb-4"
          clearable
        /> -->
        <v-spacer />
        <v-radio-group v-model="filtro" row>
          <v-radio label="Professor" value="professor"></v-radio>
          <v-radio label="Aluno" value="aluno"></v-radio>
          <v-radio label="Gestor" value="gestor"></v-radio>
        </v-radio-group>
      </v-card-title>

      <v-card-text>
        <div v-for="(pessoa, index) in pessoasFiltradas" :key="index" class="mb-8">
          <v-card class="pa-4">
            <v-tabs v-model="abas[index]" background-color="primary" dark grow>
              <v-tab>Identificação</v-tab>
              <v-tab>Dados Pessoais</v-tab>
              <v-tab v-if="pessoa.tipo_pessoa_fisica !== 'aluno'">Formação</v-tab>
              <v-tab v-if="pessoa.tipo_pessoa_fisica === 'aluno'">Deficiências</v-tab>
              <v-tab v-if="pessoa.tipo_pessoa_fisica === 'aluno'">Recursos</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abas[index]">
              <v-tab-item>
                <v-row class="mt-5">
                  <v-col cols="12"
                    ><v-text-field
                      v-model="pessoa.nomecompleto"
                      label="Nome Completo"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="12">
                    <v-radio-group v-model="pessoa.tipo_pessoa_fisica" row>
                      <v-radio label="Professor" value="professor"></v-radio>
                      <v-radio label="Aluno" value="aluno"></v-radio>
                      <v-radio label="Gestor" value="gestor"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="4"
                    ><v-text-field
                      v-model="pessoa.codigo_escola_inep"
                      label="Cód. Escola INEP"
                      dense
                      outlined
                      readonly
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="pessoa.codigo_pessoa_fisica_sistema"
                      label="Cód. Sistema"
                      dense
                      outlined
                      readonly
                  /></v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row class="mt-5">
                  <v-col cols="12" class="font-weight-bold text-md-center">
                    <h4>{{ pessoa.nomecompleto }}</h4>
                  </v-col>
                  <v-col cols="4"
                    ><v-text-field
                      maxlength="11"
                      :rules="[cpfRule]"
                      v-model="pessoa.cpf"
                      label="CPF"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="formatDateToDisplay(pessoa.data_nascimento)"
                      @input="handleDataNascimentoInput($event, index)"
                      label="Data de Nascimento"
                      dense
                      outlined
                      placeholder="dd/mm/yyyy"
                      mask="##/##/####"
                    />
                  </v-col>

                  <v-col v-if="pessoa.tipo_pessoa_fisica === 'gestor'" cols="12">
                    <v-text-field
                      v-model="pessoa.email"
                      label="E-mail"
                      outlined
                      type="email"
                      :rules="[emailRule]"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="['0 - Não declarado/Ignorado', '1 - Filiação Um e/ou Filiação Dois']"
                      v-model="pessoa.filiacao"
                      label="Filiação"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="4"
                    ><v-text-field v-model="pessoa.filiacao_1" label="Filiação 1" dense outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field v-model="pessoa.filiacao_2" label="Filiação 2" dense outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select :items="sexos" v-model="pessoa.sexo" label="Sexo" dense outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-text-field
                      v-model="pessoa.certidao_nova"
                      label="Número da matrícula da Certidão de nascimento( Certidao Nova)"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '32 - Argentina',
                        '68 - Bolívia',
                        '76 - Brasil',
                        '328 - Guiana',
                        '254 - Guiana Francesa',
                        '600 - Paraguai',
                        '604 - Peru',
                        '740 - Suriname',
                        '858 - Uruguai',
                        '862 - Venezuela',
                      ]"
                      v-model="pessoa.pais_residencia"
                      label="País de Residência"
                      dense
                      outlined
                  /></v-col>

                  <v-col cols="4">
                    <!-- adicionar mascara de cep -->
                    <v-text-field v-model="pessoa.cep" label="CEP" v-mask="'#####-###'" outlined />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="pessoa.municipio_residencia"
                      :items="municipios"
                      label="Município de Residencia"
                      clearable
                      hide-details
                      outlined
                      :item-value="(value) => String(value.codigo)"
                      :item-text="(val) => `${val.codigo} - ${val.nomeFormatado}`"
                      :return-object="false"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="4"
                    ><v-select
                      :items="cores"
                      v-model="pessoa.cor_raca"
                      label="Cor/Raça"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="nacionalidades"
                      v-model="pessoa.nacionalidade"
                      label="Nacionalidade"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '76 - Brasil', // Brasileiros natos (óbvio)
                        '32 - Argentina',
                        '484 - México',
                        '218 - Equador',
                        '170 - Colômbia',
                        '600 - Paraguai',
                        '586 - Paquistão',
                        '156 - China',
                        '380 - Itália',
                        '792 - Turquia',
                      ]"
                      v-model="pessoa.pais_nacionalidade"
                      label="País de Nacionalidade"
                      dense
                      outlined
                  /></v-col>
                  <!-- <v-col cols="4"
                    ><v-select :items="municipios"
                     v-model="pessoa.municipio_nascimento" label="Município de Nascimento" dense outlined
                  /></v-col> -->

                  <v-col cols="4">
                    <v-autocomplete
                      v-model="pessoa.municipio_nascimento"
                      :items="municipios"
                      :item-value="(value) => String(value.codigo)"
                      :item-text="(val) => `${val.codigo} - ${val.nomeFormatado}`"
                      label="Município de nascimento"
                      :return-object="false"
                      clearable
                      hide-details
                      outlined
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="4"
                    ><v-select
                      :items="['1 - Urbana', '2 - Rural']"
                      v-model="pessoa.localizacao_zona_residencia"
                      label="Localização/Zona de Residência"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '7 - Não está em área de localização diferenciada',
                        '1 - Área de assentamento',
                        '2 - Terra indígena',
                        '3 - Comunidade quilombola',
                        '8 - Área onde se localizam povos e comunidades tradicionais',
                      ]"
                      v-model="pessoa.localizacao_diferenciada"
                      label="Localização diferenciada de residência"
                      dense
                      outlined
                  /></v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="pessoa.tipo_pessoa_fisica !== 'aluno'">
                <v-row>
                  <v-col cols="12" class="font-weight-bold text-md-center">
                    <h4>{{ pessoa.nomecompleto }}</h4>
                  </v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '1 - Não concluiu o ensino fundamental',
                        '2 - Ensino Fundamental',
                        '7 - Ensino Médio',
                        '6- Educação Superior',
                      ]"
                      :return-object="false"
                      :item-value="(value) => String(value.maior_nivel_escolaridade_concluido)"
                      v-model="pessoa.maior_nivel_escolaridade_concluido"
                      label="Maior nível de escolaridade concluído"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="4"
                    ><v-select
                      :items="[
                        '1 - Formação geral',
                        '2 - Modalidade normal (magistério)',
                        '3 - Curso técnico',
                        '4 - Magistério indígena - modalidade normal',
                      ]"
                      v-model="pessoa.tipo_ensino_medio_cursado"
                      label="Tipo de ensino médio cursado"
                      dense
                      outlined
                  /></v-col>
                  <v-col cols="12">
                    <label for="">Graduações</label>
                  </v-col>
                  <v-col cols="4">
                    <!-- <v-
                      :items=""
                      :return-object="false"
                      :item-text="(item) => item.codigo"
                      :item-value="(item) => item.codigo"
                      v-model="pessoa.codigo_curso_1"
                      label="Graduação 1"
                      dense
                      solo
                    /> -->

                    <e-autocomplete
                      :items="$constants.cursosSuperioresList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.nome"
                      v-model="pessoa.codigo_curso_1"
                      label="Graduação 1"
                      dense
                      solo
                    />
                    <e-autocomplete
                      :items="$constants.cursosSuperioresList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.codigo"
                      v-model="pessoa.codigo_curso_2"
                      label="Graduação 2"
                      dense
                      solo
                    />
                    <e-autocomplete
                      :items="$constants.cursosSuperioresList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.codigo"
                      v-model="pessoa.codigo_curso_3"
                      label="Graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-model="pessoa.ano_conclusao_curso_1"
                      label="Ano de Conclusão da Graduação 1"
                      dense
                      solo
                    />
                    <v-text-field
                      type="number"
                      v-model="pessoa.ano_conclusao_curso_2"
                      label="Ano de Conclusão da Graduação 2"
                      dense
                      solo
                    />
                    <v-text-field
                      type="number"
                      v-model="pessoa.ano_conclusao_curso_3"
                      label="Ano de Conclusão da Graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>

                    <e-autocomplete
                      :items="$constants.instituicoesSuperioresList"
                      :return-object="false"
                      v-model="pessoa.inst_educacao_superior_1"
                      label="Instituição da Graduação 1"
                      dense
                      solo
                    />

                    <e-autocomplete
                      :items="$constants.instituicoesSuperioresList"
                      :return-object="false"
                      v-model="pessoa.inst_educacao_superior_2"
                      label="Instituição da Graduação 2"
                      dense
                      solo
                    />
                    <e-autocomplete
                      :items="$constants.instituicoesSuperioresList"
                      :return-object="false"
                      v-model="pessoa.inst_educacao_superior_3"
                      label="Instituição da Graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="12"> Formação/Complementação pedagógica </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <e-autocomplete
                      :items="$constants.areaConhecimentoCurricularList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.nome"
                      v-model="pessoa.area_conhecimento_1"
                      label="Área do conhecimento 1"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <e-autocomplete
                      :items="$constants.areaConhecimentoCurricularList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.nome"
                      v-model="pessoa.area_conhecimento_2"
                      label="Área do conhecimento 2"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <e-autocomplete
                      :items="$constants.areaConhecimentoCurricularList"
                      :return-object="false"
                      :item-value="(value) => value.codigo"
                      :item-text="(val) => val.nome"
                      v-model="pessoa.area_conhecimento_3"
                      label="Área do conhecimento 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="12"> Pós-Graduações concluídas </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="pessoa.nao_tem_pos_graduacao"
                      label="Não tem pós graduação concluída"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_1"
                      label="Tipo de pós-graduação 1"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_1"
                      label="Área do pós-graduação 1"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_1"
                      label="Ano de conclusão da pós-graduação 1"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_2"
                      label="Tipo de pós-graduação 2"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_2"
                      label="Área do pós-graduação 2"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_2"
                      label="Ano de conclusão da pós-graduação 2"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_3"
                      label="Tipo de pós-graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_3"
                      label="Área do pós-graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_3"
                      label="Ano de conclusão da pós-graduação 3"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_4"
                      label="Tipo de pós-graduação 4"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_4"
                      label="Área do pós-graduação 4"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_4"
                      label="Ano de conclusão da pós-graduação 4"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_5"
                      label="Tipo de pós-graduação 5"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_5"
                      label="Área do pós-graduação 5"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_5"
                      label="Ano de conclusão da pós-graduação 5"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="['1 - Especialização', '2 - Mestrado', '3 - Doutorado']"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.tipo_pos_graduacao_6"
                      label="Tipo de pós-graduação 6"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-select
                      :items="$constants.areaPosGraduacaoList"
                      :return-object="false"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.area_pos_graduacao_6"
                      label="Área do pós-graduação 6"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-text-field
                      type="number"
                      v-if="!pessoa.nao_tem_pos_graduacao"
                      v-model="pessoa.ano_pos_graduacao_6"
                      label="Ano de conclusão da pós-graduação 6"
                      dense
                      solo
                    />
                  </v-col>

                  <v-col cols="12">
                    Outros cursos específicos(Formação continuada com mínimo de 80 horas)
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.creche" label="Creche" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.pre_escola" label="Pré-escola" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.anos_iniciais"
                      label="Anos Inicias do Ensino Fundamental"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.anos_finais"
                      label="Anos Finais do Ensino Fundamental"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.ensino_medio" label="Ensino Médio" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.eja" label="Educ de Jovens e Adultos" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.educ_especial" label="Educ Especial" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.educ_indigena" label="Educ Indígena" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.educ_campo" label="Educ do Campo" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.educ_ambiental" label="Educ Ambiental" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.educ_direitos_humanos"
                      label="Educ em direitos humanos"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.educ_bilingue_surdos"
                      label="Educ bilígue de surdos"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.educ_tic"
                      label="Educ e Tecnologia de Informação e Comunicações(TIC)"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.genero_diversidade_sexual"
                      label="Gênero e Diversidade Sexual"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.direito_crianca_adolescente"
                      label="Direito de criança e adolescente"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox
                      v-model="pessoa.direito_crianca_adolescente"
                      label="Educação para as relacoes étnico raciais e História e cultura afro-brasileira e africana"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.gestao_escolar" label="Gestão Escolar" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.outros" label="Outros" dense solo />
                  </v-col>
                  <v-col cols="4">
                    <label for=""></label>
                    <v-checkbox v-model="pessoa.nenhum" label="Nenhum" dense solo />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="pessoa.tipo_pessoa_fisica === 'aluno'">
                <v-row>
                  <v-col cols="12" class="font-weight-bold text-md-center mt-3">
                    <h4>{{ pessoa.nomecompleto }}</h4>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="pessoa.deficiencia_transtorno_altas_habilidades"
                      :label="'Pessoa física com deficiência, transtorno do espectro autista e altas habilidades ou superdotação'"
                    />
                  </v-col>
                  <v-row class="ma-3" v-if="pessoa.deficiencia_transtorno_altas_habilidades">
                    <v-col v-for="campo in deficiencias" :key="campo" cols="3">
                      <v-checkbox
                        v-model="pessoa[campo]"
                        :label="formatarCampo(campo)"
                        dense
                        outlined
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-tab-item>

              <v-tab-item v-if="pessoa.tipo_pessoa_fisica === 'aluno'">
                <v-row>
                  <v-col cols="12" class="font-weight-bold text-md-center mt-3">
                    <h4>{{ pessoa.nomecompleto }}</h4>
                  </v-col>
                  <v-col v-for="campo in recursos" :key="campo" cols="3">
                    <v-checkbox
                      v-if="!pessoa.nenhum_recurso"
                      v-model="pessoa[campo]"
                      :label="formatarCampo(campo)"
                      dense
                      outlined
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="pessoa.nenhum_recurso"
                      :label="'Nenhum Recurso'"
                      dense
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-btn block color="success" @click="salvar()"> Salvar Dados</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn block @click="prevPage" v-if="currentPage != 1" class="mx-2">← Anterior</v-btn>
            <v-btn block color="error" @click="submitForm('prev')" v-if="currentPage == 1">
              <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn block color="" @click="nextPage" v-if="currentPage != totalPages" class="mx-2"
              >Próximo →</v-btn
            >
            <v-btn
              @click="submitForm('next')"
              block
              color="success"
              v-if="currentPage == totalPages"
            >
              <v-icon>mdi-chevron-right</v-icon> Salvar e ir para a próxima etapa
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="erros.length > 0">
          <v-col cols="12" class="mt-4" style="background-color: red; color: white">
            <v-card-title>Erros encontrados no preenchimento dos dados</v-card-title>
            <v-card-text>
              <ul v-for="(erro, index) in erros" :key="index">
                <li>{{ erro.mensagem }}</li>
              </ul>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
const dadosMunicipios = require("@/assets/municipios.json");

export default {
  computed: {
    pessoasFiltradas() {
      if (!this.filtroNome) return this.pessoas;
      return this.pessoas.filter(
        (p) =>
          p.nomecompleto && p.nomecompleto.toLowerCase().includes(this.filtroNome.toLowerCase())
      );
    },
  },

  data() {
    return {
      filtro: null,
      erros: [],
      municipios: [], // Lista de municípios formatados
      filtroNome: "",
      pessoas: [],
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
      emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      cpfRule: (v) => !v || /\d{11}/.test(v.replace(/\D/g, "")) || "CPF deve ter 11 dígitos",
      abas: [0],
      binarios: ["0", "1"],
      sexos: ["1 - Masculino", "2 - Feminino"],
      cores: [
        "0 - Não declarada",
        "1 - Branca",
        "2 - Preta",
        "3 - Parda",
        "4 - Amarela",
        "5 - Indígena",
      ],
      nacionalidades: [
        "1 - Brasileira",
        "2 - Brasileira - nascido no Exterior ou Naturalizado",
        "3 - Estrangeira",
      ],
      menu: false,
      deficiencias: [
        "cegueira",
        "baixa_visao",
        "visao_monocular",
        "surdez",
        "deficiencia_auditiva",
        "surdocegueira",
        "deficiencia_fisica",
        "deficiencia_intelectual",
        "deficiencia_multipla",
        "transtorno_espectro_autista",
        "altas_habilidades_superdotacao",
        "transtornos_aprendizagem",
        "discalculia",
        "disgrafia_disortografia",
        "dislalia",
        "dislexia",
        "tdah",
        "tpac",
      ],
      recursos: [
        "auxilio_ledor",
        "auxilio_transcricao",
        "guia_interprete",
        "tradutor_interprete_libras",
        "leitura_labial",
        "prova_ampliada",
        "prova_super_ampliada",
        "cd_audio",
        "prova_lingua_portuguesa",
        "prova_video_libras",
        "material_didatico_braille",
        "prova_em_braille",
        "tempo_adicional",
      ],
      municipiosNasc: [],
      municipiosRes: [],
    };
  },
  created() {
    // Carrega e prepara os dados do JSON

    this.municipios = dadosMunicipios.map((item) => ({
      nomeFormatado: `${item["Nome do município"]} - ${item["Nome UF"]
        .substring(0, 2)
        .toUpperCase()}`,
      codigo: item["Código do município"],
    }));
  },
  mounted() {
    this.getData();
  },
  watch: {
    filtro(val) {
      this.getDataFilter(val);
    },
    filtroNome() {
      this.currentPage = 1;
      this.getData(1);
    },
    currentPage(newPage) {
      if (this.filtro) return;
      this.getData(newPage);
    },
  },
  methods: {
    handleDataNascimentoInput(value, index) {
      this.pessoas[index].data_nascimento = this.formatDateToSend(value);
    },

    formatDateToDisplay(dateISO) {
      if (!dateISO) return "";
      const [ano, mes, dia] = dateISO.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatDateToSend(displayDate) {
      if (!displayDate) return "";
      const [dia, mes, ano] = displayDate.split("/");
      return `${ano}-${mes}-${dia}`;
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (!this.validar()) return;
      this.salvar();
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    async getData(page = 1) {
      this.$loaderService.open("Carregando...");
      try {
        const params = {
          page,
          per_page: this.itemsPerPage,
        };

        const res = await this.$services.censoService.getPaginatedData30(params);

        this.pessoas = res.data;
        this.totalPages = res.last_page;
        this.currentPage = res.current_page;
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.$loaderService.close();
      }
    },
    async getDataFilter(page = 1) {
      this.$loaderService.open("Carregando...");
      try {
        const params = {
          page,
          per_page: this.itemsPerPage,
        };

        const res = await this.$services.censoService.getFilterData30(this.filtro);

        this.pessoas = [];
        this.pessoas = res.data;
        this.totalPages = res.last_page;
        this.currentPage = res.current_page;
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.$loaderService.close();
      }
    },
    async pesquisarCep(cep) {
      // if (cep.length === 9) {
      //   const cepData = await this.$services.cepService.buscarDadosDoCep(cep);
      //   this.formData.cep = cepData.cep;
      //   this.formData.logradouro = cepData.rua;
      //   this.formData.bairro = cepData.bairro;
      //   this.formData.codigo_municipio = cepData.cidade;
      // }
    },
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },
    adicionarPessoa() {
      this.pessoas.push({});
      this.abas.push(0);
    },
    removerPessoa(index) {
      this.pessoas.splice(index, 1);
      this.abas.splice(index, 1);
    },

    async salvar() {
      if (!this.validar()) return;
      try {
        await this.$services.censoService.saveData(this.pessoas, "aba30");
        this.$toast.success("Dados salvos com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
    },

    async submitForm(type) {
      if (!this.validar()) return;
      try {
        await this.$services.censoService.saveData(this.pessoas, "aba30");

        if (type === "next") {
          this.$emit("event", "tab-5");
        } else {
          this.$emit("event", "tab-3");
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    formatarCampo(campo) {
      return campo.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },

    validar() {
      this.erros = [];

      const labels = {
        nomecompleto: "Nome completo",
        tipo_pessoa_fisica: "Tipo de pessoa",
        codigo_escola_inep: "Código INEP da escola",
        codigo_pessoa_fisica_sistema: "Código no sistema",
        data_nascimento: "Data de nascimento",
        filiacao: "Tem filiação?",
        filiacao_1: "Nome da mãe",
        filiacao_2: "Nome do pai",
        sexo: "Sexo",
        certidao_nova: "Número da certidão",
        pais_residencia: "País de residência",
        cep: "CEP",
        municipio_residencia: "Município de residência",
        cor_raca: "Cor/raça",
        nacionalidade: "Nacionalidade",
        pais_nacionalidade: "País de nacionalidade",
        municipio_nascimento: "Município de nascimento",
        localizacao_diferenciada: "Localização diferenciada",
        maior_nivel_escolaridade_concluido: "Escolaridade concluída",
        email: "E-mail",
        codigo_curso_1: "Curso de graduação 1",
      };

      const camposObrigatorios = [
        "nomecompleto",
        "tipo_pessoa_fisica",
        "codigo_escola_inep",
        "codigo_pessoa_fisica_sistema",
        "data_nascimento",
        "filiacao",
        // "filiacao_1",
        "sexo",
        "pais_residencia",
        "cor_raca",
        "nacionalidade",
        "pais_nacionalidade",
        "municipio_nascimento",
        "localizacao_zona_residencia",
        "localizacao_diferenciada",
      ];

      this.pessoas.forEach((pessoa, index) => {
        camposObrigatorios.forEach((campo) => {
          if (!pessoa[campo] && labels[campo] !== undefined) {
            this.erros.push({
              tipo: campo,
              mensagem: `Pessoa ${pessoa.nomecompleto}: ${labels[campo]} é obrigatório.`,
            });
          }
        });

        if (pessoa.tipo_pessoa_fisica !== "aluno" && !pessoa.maior_nivel_escolaridade_concluido) {
          this.erros.push({
            tipo: "maior_nivel_escolaridade_concluido",
            mensagem: `Pessoa ${pessoa.nomecompleto}: Escolaridade concluída é obrigatória.`,
          });
        }
        if (pessoa.tipo_pessoa_fisica === "gestor" && !pessoa.cpf) {
          this.erros.push({
            tipo: "cpf_gestor",
            mensagem: `Pessoa ${pessoa.nomecompleto}: O CPF do gestor da escola é obrigatório.`,
          });
        }

        if (
          pessoa.maior_nivel_escolaridade_concluido === "6- Educação Superior" &&
          !pessoa.codigo_curso_1
        ) {
          // os campos de graduacao 1 é obrigatorio
          this.erros.push({
            tipo: "codigo_curso_1",
            mensagem: `Pessoa ${pessoa.nomecompleto}: em Formação-> Graduações, pelo menos um curso é obrigatório.`,
          });
        }
        if (
          pessoa.maior_nivel_escolaridade_concluido === "6- Educação Superior" &&
          pessoa.codigo_curso_1 &&
          !pessoa.ano_conclusao_curso_1
        ) {
          // os campos de graduacao 1 é obrigatorio
          this.erros.push({
            tipo: "codigo_curso_1",
            mensagem: `Pessoa ${pessoa.nomecompleto}: em Formação-> Graduações, o curso foi informado porém não foi informado o ano de conclusão do mesmo.`,
          });
        }
        if (
          pessoa.maior_nivel_escolaridade_concluido === "6- Educação Superior" &&
          pessoa.codigo_curso_1 &&
          !pessoa.inst_educacao_superior_1
        ) {
          // os campos de graduacao 1 é obrigatorio
          this.erros.push({
            tipo: "codigo_curso_1",
            mensagem: `Pessoa ${pessoa.nomecompleto}: em Formação-> Graduações, o curso foi informado porém não foi informado a instituicao de ensino de conclusão do mesmo.`,
          });
        }

        if (pessoa.tipo_pessoa_fisica === "gestor" && !pessoa.email) {
          this.erros.push({
            tipo: "email",
            mensagem: `Pessoa ${pessoa.nomecompleto}: E-mail é obrigatório para gestor.`,
          });
        }
      });

      return this.erros.length === 0;
    },
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
}
</style>
